export const DIRECTOR_ROUTES = {
  actors: {
    index: {
      route: '/actors',
      tabs: {
        searchByParams: { route: 'search-by-params' },
        searchByPhoto: { route: 'search-by-photo' }
      }
    },
    show: {
      /**
       * Перейти в профиль актера
       * @param id - id пользователя
       */
      route: (id: number) => `/actors/${id}`,
      tabs: {
        profile: { route: 'profile' },
        gallery: {
          route: 'gallery',
          tabs: { photo: { route: 'photo' }, video: { route: 'video' } }
        },
        responses: { route: 'responses' }
      }
    }
  },
  projects: {
    index: '/projects',
    castings: {
      show: {
        /**
         * Перейти на страницу кастинга
         * @param projectId - id проекта
         * @param castingId - id кастинга
         */
        route: (projectId: number, castingId: number) =>
          `/projects/${projectId}/castings/${castingId}`,
        tabs: {
          responses: { route: 'responses' },
          castingInfo: { route: 'casting-info' }
        }
      },
      /**
       *  Перейти на страницу кастинга
       * @param projectId - id проекта
       * @param castingId - id кастинга
       */
      edit_casting: (projectId: number, castingId: number) =>
        `/projects/${projectId}/castings/edit/${castingId}`,
      /**
       * Перейти на страницу отклика на кастинг
       * @param projectId - id проекта
       * @param castingId - id кастинга
       * @param responseId - id отклика
       */
      response: (projectId: number, castingId: number, responseId: number) =>
        `/projects/${projectId}/castings/${castingId}/responses/${responseId}`,
      /**
       * Перейти на страницу приглашения
       * @param projectId - id проекта
       * @param castingId - id кастинга
       * @param invitationId - id приглашения
       */
      invitation: (
        projectId: number,
        castingId: number,
        invitationId: number
      ) =>
        `/projects/${projectId}/castings/${castingId}/invitations/${invitationId}`
    },
    new_project: '/projects/new-project',
    /**
     * Перейти на страницу редактирования проекта
     * @param id - id проекта
     */
    edit_project: (id: number) => `/projects/edit/${id}`,
    show: {
      /**
       * Перейти на страницу проекта
       * @param id - id проекта
       */
      route: (id: number) => `/projects/${id}`,
      tabs: {
        castings: { route: 'castings' },
        participants: { route: 'participants' }
      }
    },
    /**
     * Перейти на страницу создания кастинга
     * @param id - id проекта
     */
    new_casting: {
      /**
       * Перейти на страницу создания кастинга
       * @param id - id проекта
       */
      route: (id: number) => `/projects/${id}/new-casting`,
      tabs: {
        generalInfo: { route: 'general-info' },
        requirements: { route: 'requirements' },
        excerpt: { route: 'excerpt' },
        publication: { route: 'publication' }
      }
    }
  },
  actor_cards: {
    index: '/actor-registry'
  },
  film_offers: {
    index: '/film-offers',
    /**
     * Перейти на страницу предложения фильма
     * @param id - id предложения
     */
    show: (id: number) => `/film-offers/${id}`
  },
  profile: {
    index: '/profile'
  },
  responses: {
    index: '/responses',
    /**
     * Перейти в отклик
     * @param castingId - id кастинга
     * @param responseId - id отклика
     */
    response: (castingId: number, responseId: number) =>
      `/responses/castings/${castingId}/responses/${responseId}`,
    /**
     * Перейти в приглашение
     * @param castingId - id кастинга
     * @param invitationId - id приглашения
     */
    invitation: (castingId: number, invitationId: number) =>
      `/responses/castings/${castingId}/invitations/${invitationId}`
  }
} as const;
